module.exports = __webpack_public_path__ + "static/img/aboutUsImg2.1f4a259f.png";